import {
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Tooltip,
  Typography,
  Stack,
} from "@mui/material";

interface IProfileProductCardProps {
  imageLink: string;
  title: string;
  price: string | number;
  actionButtons: Array<{
    title: string;
    icon: React.ReactNode;
    onClick?: () => void;
    disabled?: boolean;
  }>;
  extraInfo?: string; // e.g. "Sold on Jan 15, 2025"
  onView?: () => void;
}

export const ProfileProductCard: React.FC<IProfileProductCardProps> = ({
  imageLink,
  title,
  price,
  actionButtons,
  extraInfo,
  onView,
}) => {
  return (
    <Card
      variant="outlined"
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        borderRadius: 2,
        boxShadow: "none",
        borderColor: (theme) => theme.palette.divider,
        transition:
          "box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out",
        "&:hover": {
          boxShadow: "0px 5px 10px rgba(0,0,0,0.2)",
          borderColor: "transparent",
        },
      }}
    >
      <CardMedia
        component="img"
        image={imageLink || "/placeholder.jpg"}
        alt={title}
        sx={{
          width: "100%",
          height: 150,
          objectFit: "contain",
          backgroundColor: "#fff",
          cursor: "pointer",
        }}
        onClick={onView}
      />
      <CardContent
        sx={{
          p: 1.2,
          display: "flex",
          flexDirection: "column",
          gap: 0.5,
        }}
      >
        <Typography
          variant="subtitle2"
          fontWeight="bold"
          noWrap
          sx={{ cursor: "pointer" }}
          onClick={onView}
        >
          {title}
        </Typography>

        <Typography variant="body2">{price}</Typography>

        {extraInfo && (
          <Typography variant="caption" color="text.secondary">
            {extraInfo}
          </Typography>
        )}

        <Stack direction="row" spacing={1} justifyContent="center" mt={1}>
          {actionButtons.map((action, idx) => (
            <Tooltip title={action.title} key={idx}>
              <IconButton 
                size="small" 
                onClick={action.onClick}
                disabled={action.disabled}
              >
                {action.icon}
              </IconButton>
            </Tooltip>
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};
